var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about"},[_c('aboutext',{staticClass:"text-left",staticStyle:{"font-size":"1.2em"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }